import { patchState, signalStore, withMethods, withState } from "@ngrx/signals";
import { ISubscriptionDetailsState } from "./details.model";
import { inject } from "@angular/core";
import { SubscriptionDetailsService } from "./details-service";
import { tap } from "rxjs";
import { GetSubscriptionResponse, SubscriptionActiveBilling } from "../../api/proxies";

const initialState: ISubscriptionDetailsState = {
    customer: null,
    editionName: undefined,
    price: 0,
    currentPrice: 0,
    billingCycle: null,
    startDate: null,
    items: undefined,
    loading: false,
    isEditingCreditCard: false,
    status: null,
    loadingActiveBillings: false,
    due: undefined,
    future: undefined,
};

// mock for each month
let mockedBillings: SubscriptionActiveBilling[] = [
    SubscriptionActiveBilling.fromJS({
        dueDate: new Date(new Date().setMonth(new Date().getMonth() + 1)),
        price: 49.99,
        paymentLink: undefined,
    }),
    SubscriptionActiveBilling.fromJS({
        dueDate: new Date(new Date().setMonth(new Date().getMonth() + 2)),
        price: 49.99,
        paymentLink: undefined,
    }),
];

export const DetailsStore = signalStore(
    withState(initialState),
    withMethods((store, service = inject(SubscriptionDetailsService)) => ({
        loadDetails: () => {
            return service.getSubscriptionDetails().pipe(
                tap(
                    (details: GetSubscriptionResponse) => {
                        patchState(store, {
                            customer: details.customer,
                            editionName: details.editionName,
                            price: details.price,
                            currentPrice: details.currentPrice,
                            billingCycle: details.billingCycle,
                            startDate: details.startDate,
                            items: details.items,
                            status: details.status,
                            // let's mock due and future billings for now
                            due: [{ dueDate: new Date(), price: 49.99, paymentLink: undefined }],
                            future: [...mockedBillings],
                            loading: false,
                        });
                    },
                    (error) => {
                        patchState(store, { loading: false });
                    }
                )
            );
        },
    }))
);
